import { configure, defineRule } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import ja from '@vee-validate/i18n/dist/locale/ja.json'
import * as AllRules from '@vee-validate/rules'

setLocale('ja')
configure({
  generateMessage: localize({ ja })
})

Object.entries(AllRules).forEach(([id, validator]) => {
  defineRule(id, validator)
})

// multiselectの選択数
defineRule('select_length', (value, [limit], context) => {
  if (Array.isArray(value) && value.length <= limit) {
    return true
  }
  return `${context.field}は${limit}個まで選択可能です`
})

// フィールドの比較
defineRule('comparison', (value, [target, buffer], context) => {
  if (Number(value) >= Number(target) + Number(buffer)) {
    return true;
  }
  return `${context.field}は優良ユーザーから${buffer}日以上空けてください`
})
